import React, { useEffect, useState } from "react";
import { Button, Icon, Text } from "@jarvis-catalyst/ui-components";
import { useDeviceByCiamId } from "../../hooks/useDeviceByCiamId";
import { useUser } from "../../hooks/useUser";
import { FormType } from "../../types";
import LoadingComponent from "../Loading";
import DeviceDetailModal from "../Modal/DeviceDetailModal";
import { parseDate } from "../../utils/parseDate";
import { useDeleteDeviceHook } from "../../hooks/useDeleteDevice";

type Params = {
  ciamId: string;
  username: string;
  form?: FormType;
};

const DevicesTab = ({ ciamId = "", username = "", form }: Params): JSX.Element => {
  const [deviceIdSelected, setDeviceIdSelected] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const {
    user: { token }
  } = useUser();
  const { useDeleteDevice } = useDeleteDeviceHook();
  const { setFetched, devicesByCiamIdQuery } = useDeviceByCiamId({
    ciamId,
    username,
    token,
    serviceProvider: form?.serviceProvider ?? ""
  });

  useEffect(() => {
    setFetched(true);
  }, [ciamId]);

  const handleClickDelete = async (ciamId: string, deviceId: string) => {
    await useDeleteDevice.mutateAsync({
      ciamId,
      deviceId,
      username,
      serviceProvider: form?.serviceProvider ?? ""
    });
    //setShowMenu(false);
    setFetched(true);
  };

  if (openModal) {
    return (
      <DeviceDetailModal
        isOpen={openModal}
        setIsOpen={setOpenModal}
        title="Device Details"
        size="lg"
        deviceId={deviceIdSelected}
        serviceProvider={form?.serviceProvider ?? ""}
        username={username}
        ciamId={ciamId}
      />
    );
  }

  return (
    <>
      {devicesByCiamIdQuery.isLoading ? (
        <>
          <LoadingComponent />
        </>
      ) : (
        devicesByCiamIdQuery.data?.map((device, index) => (
          <div key={index}>
            <div className="row g-3">
              <div className="col-8">
                <Text className="form-label">Device ID</Text>
                <input type="text" className="form-control" disabled value={device.deviceId ?? ""} />
              </div>
              <div className="col-4 d-flex align-items-end" style={{ gap: "2px" }}>
                <Button
                  className="btn btn-primary"
                  onClick={() => {
                    setOpenModal(true);
                    setDeviceIdSelected(device.deviceId);
                  }}
                >
                  <Icon name="View" color="white" size={24} />
                </Button>
                <div className="position-relative">
                  <Button className="btn btn-primary" onClick={() => setShowMenu((prev) => !prev)}>
                    <Icon name="MenuBurger" color="white" size={24} />
                  </Button>

                  {showMenu && (
                    <ul
                      className="dropdown-menu show"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        zIndex: 1000,
                        display: "block"
                      }}
                    >
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            handleClickDelete(ciamId, device.deviceId);
                            setShowMenu(false);
                          }}
                        >
                          Delete
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              </div>

              <div className="col-12">
                <Text className="form-label">Hash</Text>
                <textarea className="form-control" disabled value={device.hash ?? ""} />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">IP Address</Text>
                <input type="text" className="form-control" disabled value={device.ip ?? ""} />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">First Seen At</Text>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={parseDate(String(device.firstSeenAt), "dd/MM/yyyy")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">Last Seen At</Text>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={parseDate(String(device.lastSeenAt), "dd/MM/yyyy")}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">Device Name</Text>
                <input type="text" className="form-control" disabled value={device.deviceName ?? ""} />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">Device Type</Text>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={String(device.deviceType)?.toUpperCase()}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">Location</Text>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={String(device.geoLocation?.country) ?? ""}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">Recognized</Text>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={device.recognizedDevice === true ? "Yes" : "No"}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Text className="form-label">Recognized At</Text>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={
                    device.recognizedChallengeAt
                      ? parseDate(String(device.recognizedChallengeAt), "dd/MM/yyyy HH:mm:ss")
                      : ""
                  }
                />
              </div>
            </div>
            <hr />
          </div>
        ))
      )}
    </>
  );
};

export default DevicesTab;
